export { default } from './WorkAttribution';
